import { useEffect } from 'react';
import { useSubstate } from 'use-substate';

import { client, useErrorNotifications } from 'core/http';
import { SetRoles } from 'core/Store/roles/actions';
import { selectRoles } from 'core/Store/roles/selectors';
import { Role } from 'core/types/role';

let loading = false;

export default function useRoles() {
  const showErrorNotification = useErrorNotifications();
  const [roles, dispatch] = useSubstate(selectRoles);

  useEffect(() => {
    if (roles.length || loading) {
      return;
    }

    loading = true;

    client()
      .get<Role[]>('roles')
      .then(response => response.data)
      .then(roles => dispatch(new SetRoles(roles)))
      .catch(showErrorNotification)
      .finally(() => (loading = false));
  }, [dispatch, roles, showErrorNotification]);

  return roles;
}
